export default __webpack_public_path__ + "static/media/picintro.c4cc758e.png";